import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

//
import ReactApexChart from "react-apexcharts";
import { Card, Col } from "react-bootstrap";

//
import ImageBox from "../general/ImageBox";

//
import { iconImage } from "../../redux/features/coins/actions";

function BestInWeeksItem({ item }) {
  const colors = ["#fff", "#e6fbf3", "#c7f5e5"];
  const [key, setKey] = useState(0);
  const [option, setOption] = useState({
    series: [
      {
        name: "",
        data: [],
      },
    ],
    chart: {
      type: "area",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    labels: [],

    dataLabels: {
      enabled: false,
    },

    stroke: {
      curve: "smooth",
      colors: ["#63e4b5"],
      width: 3,
    },

    xaxis: {
      labels: {
        style: {
          colors: "#B4B9C0",
        },
      },
      tickAmount: 6,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      tickAmount: 4,
      floating: false,

      labels: {
        style: {
          colors: "#E6E8EA",
        },
        // offsetY: -7,
        offsetX: -15,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.1,
        opacityTo: 0.9,
        stops: [0, 90, 95],
        colors: colors,
      },
    },
    tooltip: {
      enabled: true,
      marker: {
        show: true,
      },
      y: {
        formatter: function (
          value,
          { series, seriesIndex, dataPointIndex, w }
        ) {
          return `${value}`;
        },
      },

      x: {
        format: "MMM dd ,yyyy",
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        left: 0,
        right: 0,
      },
    },
  });

  useEffect(() => {
    let chart = { ...option };
    let series = [];
    let labels = [];

    for (let i = 0; i < item.chart.length; i++) {
      const element = item.chart[i];
      series.push(Number(element.value).toFixed(2));
      labels.push(element.time);
    }

    chart.series[0].name = item.name;
    chart.series[0].data = series;
    chart.labels = labels;

    setOption(chart);

    setKey(key + 1);
  }, []);
  return (
    <Col md={6} xl={4} className="item gutter-b">
      <Card>
        <Card.Header>
          <div className="d-flex align-items-center">
            <ImageBox src={iconImage(item.symbol)} />
            <div>
              <h5>{item.name}</h5>
              <small className="fw-bold">{item.symbol}</small>
            </div>
          </div>

          <div className="change-percent">
            <small>1h change</small>
            <small
              className={`fw-bolder ${
                +item.percent_change_1h > 0 ? "text-success" : "text-danger"
              }`}
            >
              {item.percent_change_1h}%
            </small>
          </div>
        </Card.Header>

        <Card.Body className="py-0">
          <ReactApexChart
            key={key}
            options={option}
            series={option.series}
            type="area"
            height={200}
          />
        </Card.Body>
      </Card>
    </Col>
  );
}

BestInWeeksItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default BestInWeeksItem;
